import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-disable",
  "use": "icon-disable-usage",
  "viewBox": "0 0 63 63",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 63 63\" id=\"icon-disable\"><path d=\"M31.52,0A31.49,31.49,0,1,1,0,31.43,31.47,31.47,0,0,1,31.52,0ZM44.39,50.37,12.63,18.6A22.85,22.85,0,0,0,44.39,50.37Zm6.16-6.23a22.79,22.79,0,0,0-3.9-29.81C37.4,6.14,25.11,7.84,18.88,12.46Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol